import { createSlice } from "@reduxjs/toolkit";

export const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    resetCategory: (state) => {
      state.isFetching = false;
      state.error = false;
    },
    //GET ALL
    getCategoryStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getCategorySuccess: (state, action) => {
      state.isFetching = false;
      state.categories = action.payload;
    },
    getCategoryFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getCategoryProductSuccess: (state, action) => {
      state.isFetching = false;
    },
  },
});

export const {
  resetCategory,
  getCategoryStart,
  getCategorySuccess,
  getCategoryFailure,
  getCategoryProductSuccess,
} = categorySlice.actions;

export default categorySlice.reducer;
